import { SocialMediaPlatform } from '../../../interfaces';

export const SOCIAL_PLATFORM_HEADER_TEXTS: Partial<Record<SocialMediaPlatform, string>> = {
  [SocialMediaPlatform.YouTube]: 'Published on YouTube',
  [SocialMediaPlatform.Twitter]: 'Posted on X',
  [SocialMediaPlatform.Instagram]: 'Posted on Instagram',
  [SocialMediaPlatform.Spotify]: 'Shared from Spotify',
  [SocialMediaPlatform.TikTok]: 'Posted on TikTok',
};

export const POST_TYPE_TEXT = {
  publishedVideo: 'Published a video',
  publishedPost: 'Published a post',
  pinned: 'Pinned',
} as const;
